<template>
  <div class="home">
    <img alt="Anima logo" src="../assets/logo.png">
    <span>Welcome to Anima's admin panel.</span>
    <span>Unfortunately, this page is still under constructions, so try again later! :)</span>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
};
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.home img {
  height: 100px;
}
</style>
